export const US_SELF_DRIVE_DRIVER_CUTOFF_REASON =
  "us_self_drive_driver_cutoff" as const;

/**
 * The API's canonical outbox code is the only reliable discriminator. Do not
 * infer this case from cancellation-reason labels, free text, or booking facts.
 */
export function isUsSelfDriveCutoffCancellation(trip: {
  status?: string | null;
  cancellationReasonCode?: string | null;
} | null | undefined): boolean {
  return trip?.status?.toLowerCase() === "cancelled"
    && trip.cancellationReasonCode === US_SELF_DRIVE_DRIVER_CUTOFF_REASON;
}